import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from './base';
import { InvoiceReportDTO } from '../../models/billing';
import { Response } from '../../models/shared';

const billingApi = createApi({
  reducerPath: 'billingApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['billing'],
  endpoints: (builder) => ({
    getInvoicesReport: builder.query<InvoiceReportDTO | null, { start: string; end: string; include_pending?: boolean }>({
      query: ({ start, end, include_pending }) => ({
        url: '/billing/invoices-report',
        method: 'GET',
        params: { start, end, include_pending },
      }),
      providesTags: ['billing'],
      transformResponse: (response: Response<InvoiceReportDTO>) => response.data || null,
    }),
  }),
});

export const {
  useGetInvoicesReportQuery,
} = billingApi;

export { billingApi };
